<template>
  <div class="w-full">
    <div class="mb-14 mt-6">
      <h2 class="text-center text-2xl tracking-tighter leading-9 font-bold mb-2">
        <!--{{ location.title }}-->
        Sign In
      </h2>
      <p class="text-sm mt-2 opacity-75 text-center leading-5">
        <!--{{ $auth.location }}.ovatu.com-->
        {{ location.title }}
      </p>
    </div>

    <input
      ref="email"
      v-model="_email"
      aria-label="Email address"
      placeholder="Email address"
      name="email"
      type="email"
      autocomplete="off"
      required
      class="field appearance-none relative block text-base w-full px-3 py-3 border border-gray-200 dark:border-gray-800 bg-white/20 dark:bg-gray-900/75 rounded-xl placeholder-gray-500 dark:placeholder-white/50 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:leading-5"
      @keydown.enter="handleKeyDown"
    >

    <div class="mt-8">
      <nuxt-link
        to="/auth/login/password"
        class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        :class="[{ 'pointer-events-none opacity-75' : !valid }, `bg-primary-${$auth.theme.light.shade} dark:bg-primary-${$auth.theme.dark.shade}`]"
        :disabled="!valid"
      >
        Enter password
      </nuxt-link>

      <div class="flex items-center space-x-3 my-4">
        <div class="w-1/2 border-b border-gray-800 dark:border-gray-700 opacity-25" />
        <p class="text-xs opacity-75">
          Or
        </p>
        <div class="w-1/2 border-b border-gray-800 dark:border-gray-700 opacity-25" />
      </div>

      <nuxt-link
        to="/auth/login/code"
        class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        :class="[{ 'pointer-events-none opacity-75' : !valid }, `bg-primary-${$auth.theme.light.shade} dark:bg-primary-${$auth.theme.dark.shade}`]"
        :disabled="!valid"
      >
        Send me a code
      </nuxt-link>
    </div>

    <div class="mt-12 text-xs text-center">
      <div v-if="$auth.accountIDs.length" class="mb-2">
        <p class="opacity-75">
          Already logged in?
          <nuxt-link to="/auth/switch" class="text-blue-500 font-medium">
            Select an existing account
          </nuxt-link>
        </p>
      </div>
      <div>
        <p class="opacity-75">
          Wrong domain? <a :href="`https://${$auth.url}/auth/find/domain`" class="text-blue-500 font-medium">Find a different domain</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  layout: 'auth',
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  computed: {
    _email: {
      get () {
        return this.$store.state.auth.auth.email
      },
      set (value) {
        this.$store.commit('auth/set', { key: 'email', value })
      }
    },
    valid () {
      return String(this._email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    }
  },
  mounted () {
    this.$refs.email.focus()
  },
  methods: {
    handleKeyDown () {
      if (this.valid) {
        this.$router.push('/auth/login/password')
      }
    }
  }
}
</script>
